import { createAction } from "@reduxjs/toolkit";
import { Pageable } from "../../services/pageable";
import { FetchableError, FetchableSuccess } from "../common/fetchable/helpers";
import { WalletsDTO } from "./models/dto";

export namespace WalletsActions {
  export enum ActionTypes {
    getWallets = "Wallets: Get Wallets",
    setWallets = "Wallets: Set Wallets",
    setPagination = "Wallets: Set Pagination",
    resetWallets = "Wallets: Reset Wallets",
    getSingleWallet = "Wallets: Get Single Wallet",
    setSingleWallet = "Wallets: Set Single Wallet",

    getWalletsSummary = "Wallets: Get Wallets Summary",
    setWalletsSummary = "Wallets: Set Wallets Summary",
    resetWalletsSummary = "Wallets: Reset Wallets Summary",

    getTotalBalance = "Wallets: Get Verified Wallets",
    setTotalBalance = "Wallets: Set Verified Wallets",
    resetTotalBalance = "Wallets: Reset Verified Wallets",

    setLoyalty = "Wallets: Set Loyalty",
  }

  // Store Wallets
  export const getWallets = createAction(ActionTypes.getWallets);
  export const resetWallets = createAction(ActionTypes.resetWallets);

  export const setWallets = createAction<
    FetchableSuccess<WalletsDTO.Responses.GetAll.T> | FetchableError,
    ActionTypes.setWallets
  >(ActionTypes.setWallets);

  export const getSingleWallet = createAction<
    WalletsDTO.Responses.GetSingle.T["id"],
    ActionTypes.getSingleWallet
  >(ActionTypes.getSingleWallet);

  export const setSingleWallet = createAction<
    { id: string; result: WalletsDTO.Responses.GetSingle.T },
    ActionTypes.setSingleWallet
  >(ActionTypes.setSingleWallet);

  export const setPagination = createAction<
    Pageable.T<keyof WalletsDTO.Responses.GetSingle.T>,
    ActionTypes.setPagination
  >(ActionTypes.setPagination);

  //------------------------ Wallets Summary

  export const getWalletsSummary = createAction(ActionTypes.getWalletsSummary);

  export const resetWalletsSummary = createAction(
    ActionTypes.resetWalletsSummary
  );

  export const setWalletsSummary = createAction<
    FetchableSuccess<WalletsDTO.Responses.GetWalletsSummary.T> | FetchableError,
    ActionTypes.setWalletsSummary
  >(ActionTypes.setWalletsSummary);

  export const getTotalBalance = createAction(ActionTypes.getTotalBalance);

  export const resetTotalBalance = createAction(ActionTypes.resetTotalBalance);

  export const setTotalBalance = createAction<
    FetchableSuccess<WalletsDTO.Responses.GetTotalBalance.T> | FetchableError,
    ActionTypes.setTotalBalance
  >(ActionTypes.setTotalBalance);

  export const setLoyalty = createAction<
    WalletsDTO.Responses.RefreshWallet.T,
    ActionTypes.setLoyalty
  >(ActionTypes.setLoyalty);

  export type GetWallets = ReturnType<typeof getWallets>;
  export type ResetWallets = ReturnType<typeof resetWallets>;
  export type SetWallets = ReturnType<typeof setWallets>;
  export type SetSingleWallet = ReturnType<typeof setSingleWallet>;
  export type GetSingleWallet = ReturnType<typeof getSingleWallet>;
  export type SetPagination = ReturnType<typeof setPagination>;

  export type GetWalletsSummary = ReturnType<typeof getWalletsSummary>;
  export type SetWalletsSummary = ReturnType<typeof setWalletsSummary>;
  export type ResetWalletsSummary = ReturnType<typeof resetWalletsSummary>;

  export type SetTotalBalance = ReturnType<typeof setTotalBalance>;
  export type GetTotalBalance = ReturnType<typeof getTotalBalance>;
  export type ResetTotalBalance = ReturnType<typeof resetTotalBalance>;

  export type SetLoyalty = ReturnType<typeof setLoyalty>;

  export type Actions =
    | GetWallets
    | SetWallets
    | ResetWallets
    | SetPagination
    | SetSingleWallet
    | GetSingleWallet
    | GetWalletsSummary
    | SetWalletsSummary
    | ResetWalletsSummary
    | GetTotalBalance
    | SetTotalBalance
    | ResetTotalBalance
    | SetLoyalty;
}
